<template>
  <div class="businessTripPage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="businessInput.applicantName"
        v-if="mode != 'add'"
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        required
        readonly
        label="申请人："
        class="ggInput"
      />
    </van-cell-group>
    <!-- 随行人员 -->
    <van-cell-group class="itemPerson beizhu">
      <van-field
        v-model="businessInput.travelNames"
        :required="editType"
        type="textarea"
        label="参加人员："
        :placeholder="editType ? '请选择' : ''"
        @click="checkRetinuePicker"
        :is-link="editType"
        readonly
        rows="1"
        autosize
      />
    </van-cell-group>
    <!-- 所属项目 -->
    <van-cell-group class="itemSite beizhu">
      <van-field
        v-model="businessInput.projectName"
        :required="editType"
        type="textarea"
        label="所属项目："
        :placeholder="editType ? '请选择' : ''"
        @click="checkItemPicker"
        :is-link="editType"
        readonly
        rows="1"
        autosize
      />
    </van-cell-group>
    <!-- 请假时间 -->
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="businessInput.startTime"
        :required="editType"
        label="开始时间："
        readonly
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="TimePicker(1)"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="businessInput.endTime"
        :required="editType"
        label="结束时间："
        readonly
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="TimePicker(2)"
        class="ggInput"
      />
    </van-cell-group>
    <div class="leaveDats" v-if="showInput">
      <ul>
        <li>
          <van-cell-group class="baseNone baseSalary moreLeaveText">
            <van-field
              type="number"
              :required="editType"
              v-model="businessInput.leaveDays"
              label="出差天数（天）："
              :placeholder="editType ? '请输入...  ' : ''"
              readonly
              class="ggInput"
            />
          </van-cell-group>
        </li>
      </ul>
    </div>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="businessInput.travelModeName"
        :required="editType"
        label="出行方式："
        readonly
        :placeholder="editType ? '请选择' : ''"
        @click="showTravelPicker"
        :is-link="editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        v-model="businessInput.reason"
        rows="1"
        autosize
        :required="editType"
        label="出差内容："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="editType == true ? false : true"
      />
    </van-cell-group>
    <!-- 附件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="businessInput"
      :editType="editType"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-else
      :filesData="businessInput"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && businessInput.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="businessInput"></audit-list>
    </div>
    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="mode !== 'add' && businessInput.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="businessInput"></flow-staff>
      <flow-list :workflowCode="businessInput.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="businessInput"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="businessInput.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="businessInput.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        businessInput.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          businessInput.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          businessInput.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">审批</van-button>
    </div>
    <!-- 弹出层 -->
    <!--  随行人员管理 -->
    <van-popup v-model="showRetinuePicker" position="bottom" class="roleBox">
      <retinue-view
        :retinueUids="businessInput.travelUids"
        @setReview="setRetinue"
      ></retinue-view>
    </van-popup>
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 时间控件 -->
    <van-popup v-model="showTimePickerOne" position="bottom">
      <van-datetime-picker
        type="datetime"
        :filter="filterOne"
        @cancel="showTimePickerOne = false"
        @confirm="onTimeConfirmOne"
        @change="timeChange"
        :min-date="minDate"
      />
    </van-popup>
    <van-popup v-model="showTimePickerTwo" position="bottom">
      <van-datetime-picker
        type="datetime"
        :filter="filterTwo"
        @cancel="showTimePickerTwo = false"
        @confirm="onTimeConfirmTwo"
        :min-date="minDate"
      />
    </van-popup>
    <!-- 出行方式弹框 -->
    <van-popup v-model="showTravelModePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="travelModeList"
        value-key="dictName"
        @cancel="showTravelModePicker = false"
        @confirm="saveTravelMode"
      />
    </van-popup>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPagePicker" />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const retinueView = () => import("@/components/businessTripMould/retinueView");
const projectView = () => import("@/components/businessTripMould/projectView");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const flowStaff = () => import("@/components/common/flowStaff");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
import {
  dateTimeFormat,
  intervalTime,
  diffMonth,
  getCurData,
  getDictList,
  isEdit,
} from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "businessTrip",
  data() {
    return {
      mode: "add",
      editType: false, //能否编辑
      baseUrl: process.env.BASE_URL,
      refreshPagePicker: false,
      verifyPageType: false, //审批弹框,默认不显示

      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      businessInput: {
        id: "",
        applicantId: "", //申请人id
        applicantName: "", //申请人姓名
        travelUids: [], //随行人员id
        travelNames: "", //随行人员姓名
        projectId: "", //项目编号
        projectName: "", //项目名称
        startTime: "", //请假开始时间
        endTime: "", //请假结束时间
        leaveDays: "", //出差天数
        travelMode: "", //出行方式
        travelModeName: "", //出行方式名称
        reason: "", //出差内容
        verifyStatus: "hold", //详情的当前状态
        baseAnnexes: [], //附件
      },
      showRetinuePicker: false, //随行人员弹框
      showItemPicker: false, //所属项目弹框
      showTimePicker: false, //时间控件
      showTimePickerOne:false,
      showTimePickerTwo:false,
      currentDate: new Date(), //当前时间
      minDate: new Date(getCurData()),
      checkIndex: "", // 获取证书发放和到期时间
      travelModeList: [], //出行方式列表
      showTravelModePicker: false, //出行方式弹框
      showInput: false, //控制每月请假天数框的显示
      sendType: "", //判断是否在抄送列表
      clientType: getDeviceType(),
      is_weixn: is_wei(), //是否为微信
      hour:'08',//选择的是08点的时候
    };
  },
  components: {
    retinueView,
    projectView,
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  async mounted() {
    if (is_wei()) {
      document.title = "出差申请";
    }

    window.editPage = this.editPage; //编辑页面
    this.travelModeList = await getDictList("chucingfangshi");
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.$nextTick(function () {
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载
      if (this.userinfo && this.userinfo.id) {
        this.businessInput.applicantName =
          this.mode == "add" ? this.userinfo.realName : "";
        this.businessInput.applicantId =
          this.mode == "add" ? this.userinfo.id : "";
      }
      this.mode !== "add" ? (this.commonId ? this.getDetails() : "") : "";
      this.mode == "add" ? "" : (this.showInput = true);
      if (this.mode == "add" && this.userinfo && this.userinfo.id) {
        console.log(this.userinfo, "userinfo");
        let selfList = [this.userinfo];
        window.sessionStorage.setItem("moreRetinueList",JSON.stringify(selfList));
        this.businessInput.travelNames = this.userinfo.realName;
        this.businessInput.travelUids = [this.userinfo.id];
      }
    });
  },
  methods: {
    //获取请假天数
    getWorkDays() {
      let _this = this;
      console.log(_this.businessInput.startTime,'_this.applyInput.startTime')
      if(_this.businessInput.startTime && _this.businessInput.endTime){
        _this.$api.administration.administration.getWorkDays({ 
          endTime: _this.businessInput.endTime,
          startTime:_this.businessInput.startTime,
          excludeHoliday:false,
        }).then((res) => {
            if (res.code == "1") {
              _this.$set(_this.businessInput, "leaveDays", res.data);
            } else {
              _this.$toast(res.msg);
            }
        });
      }
    },
    timeChange(picker){
      let v=picker.getValues()
      this.hour=v[3];
    },
    filterOne(type, options) {
      console.log('type, options')
      if (type === "hour") {
        return ['08','14'];
      }
      if (type === "minute") {
        return this.hour == "08"?['30']:['00'];
      }
      return options;
    },
    filterTwo(type, options) {
      if (type === "hour") {
        return ['12','18'];
      }
      if (type === "minute") {
        return ['00'];
      }
      return options;
    },
    ...mapMutations(["setShowLoad", "setAppData"]),
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    /*获取详情*/
    getDetails() {
      let _this = this;
      _this.$api.administration.administration.business
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.businessInput = res.data;
            if (
              (_this.businessInput.verifyStatus == "hold" ||
                _this.businessInput.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
        });
    },
    /*获取随行人员控件*/
    checkRetinuePicker() {
      if (this.editType) {
        this.showRetinuePicker = true;
      }
    },

    /*选择出行方式*/
    showTravelPicker() {
      if (this.editType) {
        this.showTravelModePicker = true;
      }
    },
    saveTravelMode(data) {
      this.showTravelModePicker = false;
      this.businessInput.travelModeName = data.dictName;
      this.businessInput.travelMode = data.dictCode;
    },
    /*获取人员信息*/
    setRetinue(data) {
      console.log(JSON.stringify(data));
      if (data != "") {
        this.businessInput.travelNames = data.names;
        this.businessInput.travelUids = data.ids;
      }
      this.showRetinuePicker = false;
    },
    changeTravelNames(names) {
      console.log(names);
      let cc = names;
      return cc;
    },
    /*显示所属项目控件*/
    checkItemPicker() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    /*获取所属项目数据*/
    setProject(data) {
      if (data != "") {
        this.businessInput.projectId = data.id;
        this.businessInput.projectName = data.name;
      }
      this.showItemPicker = false;
    },
    /*获取时间控件*/
    TimePicker(type) {
      if (this.editType) {
        this.checkIndex = type;
        type==1?this.showTimePickerOne=true:this.showTimePickerTwo=true
      }
    },
    /*获取时间数据*/
    // onTimeConfirm(data) {
    //   this.showTimePicker = false;
    //   if (this.checkIndex == "1") {
    //     this.businessInput.startTime = dateTimeFormat(data);
    //     this.showInput = true;
    //   } else {
    //     this.businessInput.endTime = dateTimeFormat(data);
    //     this.showInput = true;
    //   }
    // },
/*获取时间数据*/
onTimeConfirmOne(data) {
      let h=data.getHours();
      if(h==8){
        data.setMinutes(30);
      }else{
        data.setMinutes(0);
      }
      this.showInput = true;
      this.showTimePickerOne = false;
      this.businessInput.startTime = dateTimeFormat(data);
      this.getWorkDays();
    },
    onTimeConfirmTwo(data) {
      data.setMinutes(0);
      this.showTimePickerTwo = false;
      this.showInput = true;
      this.businessInput.endTime = dateTimeFormat(data);
      this.getWorkDays();
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.businessInput.baseAnnexes = data;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      /*校验*/

      if (
        _this.businessInput.applicantId &&
        _this.businessInput.travelUids &&
        _this.businessInput.travelUids.length > 0 &&
        _this.businessInput.projectId &&
        _this.businessInput.leaveDays &&
        _this.businessInput.travelMode &&
        _this.businessInput.reason
      ) {
        _this.mode = msg;
        _this.saveAll();
      } else {
        _this.$toast("带星号为必填，不能为空");
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.administration.administration.business
        .busSave(_this.mode, _this.businessInput)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
          _this.btnLoading = false;
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;

      let msg = _this.businessInput.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.administration.administration.business
            .operate(_this.businessInput.verifyStatus, _this.businessInput.id)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.$toast("网络失败，稍后重试");
              _this.btnLoading = false;
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.businessInput.applicantName =
            this.mode == "add" ? this.userinfo.realName : "";
          this.businessInput.applicantId =
            this.mode == "add" ? this.userinfo.id : "";
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.businessTripPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    // overflow-y: initial;
  }
  #searchHeight {
    text-align: left;
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .van-cell,
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreLeaveText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      height: 45px;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        display: inline-block;
        height: 45px;
        line-height: 45px;
      }
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin: 10px 0 45px 0;
  }
  //审批操作样式
}
</style>